import { FC, ReactNode } from "react";
import { Col, Row, Typography } from "antd";
import { CardBody, DocsButton, ExtraBox, TitleRow, Wrapper } from "./styled";
import { WDCardBodyElement } from "./WDCardBodyElement";
import { EApproveStatus, TDocumentsResponse } from "../../types";

// WD (РД) - working documentation (рабочая документация)
interface IWDCard {
  documents: TDocumentsResponse;
  extraContent?: ReactNode;
  isHighlighted?: boolean;
  links?: TWDCardExtraItem[];
  title: string;
  versionType: "actualVersion" | "newVersion";
}

export type TWDCardExtraItem = {
  icon?: ReactNode;
  text: string;
  link?: string;
  onClick?: () => void;
};

export const WDCard: FC<IWDCard> = ({
  documents,
  extraContent,
  isHighlighted = false,
  links,
  title,
  versionType,
}) => {
  const { [versionType]: documentation, role } = documents;

  const chooseInWorkMessage = (): string => {
    if (!documentation?.approvedAt && !documentation?.approved) {
      return role.isContractor
        ? "Проектный институт выпустил новую рабочую документацию, дождитесь, пока она будет выпущена в производство работ"
        : "Выпущена новая РД со стороны проектного института. Когда она будет выпущена в производство работ, статус изменится";
    }

    return "";
  };

  const chooseContractorsMessage = (): string => {
    if (
      versionType === "actualVersion" &&
      documentation?.status !== EApproveStatus.ACTUAL
    ) {
      if (role.isContractor && role.contractorIsResponsible) {
        return 'Вы получили новую версию документации, нажмите "Принять" и начните с ней работать';
      } else if (!role.isContractor) {
        return 'Когда все подрядчики примут рабочую документацию в работу, статус изменится на "Принято"';
      }
    }

    return "";
  };

  return (
    <Wrapper data-testid="wd-card" $isHighlighted={isHighlighted}>
      <TitleRow className="row-not-last-child" 
       align="middle">
        <Typography.Title className="title" level={5}>{title}</Typography.Title>
        <Typography.Title className="title-last-child" style={{margin: "8px 0 "}} level={5}>— версия {documentation?.version}</Typography.Title>
      </TitleRow>

      <CardBody>
        <WDCardBodyElement
          dateOrStatus={documentation?.createdAt!}
          text="Дата загрузки"
        />

        <WDCardBodyElement
          dateOrStatus={
            documentation?.approvedAt
              ? documentation?.approvedAt!
              : documentation?.approved!
          }
          isHighlighted={false}
          text="В производстве работ"
          tooltipText={chooseInWorkMessage()}
        />

        {/* {versionType === "actualVersion" && ( */}
          <WDCardBodyElement
            dateOrStatus={documentation?.status === EApproveStatus.ACTUAL}
            text="Подрядчики"
            tooltipText={chooseContractorsMessage()}
          />
        {/* )} */}
      </CardBody>

      {(!!links?.length || extraContent) && (
        <ExtraBox>
          <Row align="middle" justify="start" gutter={16}>
            {links?.map((el) => (
              <Col key={el.text}>
                {el.link ? (
                  <a target="_blank" rel="noopener noreferrer" href={el.link}>
                    <DocsButton className="button" icon={el.icon} type="link">
                      {el.text}
                    </DocsButton>
                  </a>
                ) : (
                  <DocsButton className="button" icon={el.icon} onClick={el.onClick} type="link">
                    {el.text}
                  </DocsButton>
                )}
              </Col>
            ))}
          </Row>

          {extraContent}
        </ExtraBox>
      )}
    </Wrapper>
  );
};
